<a
    class="text-interactive-coral text-copy-l font-bold inline-flex flex-row gap-1 align-items-center no-underline hover:no-underline group"
    [href]="url() | translate"
    [attr.aria-label]="
        blankTab()
            ? ((ariaLabel() | translate) + ' ' + ('common.opens-in-new-tab' | translate))
            : (ariaLabel() | translate)
    "
    (click)="linkClicked($event)"
>
    <span class="underline hover:underline">{{ label() | translate }}</span>

    @if (hasIndicator()) {
        @if (isDownload()) {
            <span class="element-download text-2xl"></span>
        }
        @if (!urlPartsSignal().isInternal) {
            <span class="element-right-2 text-2xl"></span>
        }
    }
</a>
